import React, { useEffect } from 'react';
import '../../css/components/bronson/Loading.css';

function Loading({ariaBusy, disableIcon}) {

    return (
        <div className="c-spinner c-spinner--full-page" aria-live="polite" aria-busy={ariaBusy ? "true" : "false"}>
            <div className={"c-spinner__loader " + (disableIcon ? "c-spinner__loader--none" : "")}>
                <span className="c-spinner__element"></span>
                <span className="c-spinner__element"></span>
                <span className="c-spinner__element"></span>
                <span className="c-spinner__element"></span>
                <span className="c-spinner__element"></span>
                <span className="c-spinner__element"></span>
                <span className="c-spinner__element"></span>
                <span className="c-spinner__element"></span>
            </div>
        </div>
    )

}

export default Loading;